import { ProductFitScreen_ViewVariant } from "~/generated/interview_service"
import { TTString } from "~/components/shared/AttributedString"

const topScreen = {
  activeColor: "Other/Green",
  bgImage: "https://storage.pora.ai/45c4aced9015de2d43873e8f6751559b.webp",
  bgColor: "#0E204E",
  infiniteLine: true,
  prevTotalProductsCount: 31,
  totalProductsCount: 20,
  fitPercentage: 100,
  prevFitPercentage: 88,
  title1: { parts: [{ content: " products", format: [] }] },
  title2: {
    parts: [{ content: " fit to you", format: [] }],
  },
  buttonUpTitle: "All done!",
}

export const SCREEN_CONFIG_VARIANTS: Record<
  ProductFitScreen_ViewVariant,
  {
    activeColor: string
    bgColor: string
    bgImage: string
    moreProductsTitle?: string
    title1: TTString
    title2: TTString
    infiniteLine?: boolean
    prevTotalProductsCount?: number
    totalProductsCount: number
    fitPercentage: number
    prevFitPercentage?: number
    buttonUpTitle?: string
  }
> = {
  [ProductFitScreen_ViewVariant.bad]: {
    activeColor: "Other/Error",
    bgColor: "#340D08",
    bgImage: "https://storage.pora.ai/90f54d46f065ef7fc63ad63e3a9cd935.webp",
    moreProductsTitle: "+377",
    totalProductsCount: 390,
    fitPercentage: 48,
    title1: { parts: [{ content: " products", format: [] }] },
    title2: {
      parts: [{ content: " fit to you", format: [] }],
    },
  },
  [ProductFitScreen_ViewVariant.mild]: {
    activeColor: "Other/Warning",
    bgImage: "https://storage.pora.ai/784dd3fc615049ae1aa15efb9e7c589d.webp",
    bgColor: "#3C2907",
    moreProductsTitle: "+89",
    prevTotalProductsCount: 390,
    totalProductsCount: 102,
    fitPercentage: 67,
    prevFitPercentage: 48,
    title1: { parts: [{ content: " products", format: [] }] },
    title2: {
      parts: [{ content: " fit to you", format: [] }],
    },
  },
  [ProductFitScreen_ViewVariant.green]: {
    activeColor: "#A6C747",
    bgImage: "https://storage.pora.ai/5daa68397dc2f44adb836a0287ffcd5b.webp",
    moreProductsTitle: "+50",
    prevTotalProductsCount: 102,
    totalProductsCount: 63,
    fitPercentage: 74,
    prevFitPercentage: 67,
    bgColor: "#1D280A",
    title1: { parts: [{ content: " products", format: [] }] },
    title2: {
      parts: [{ content: " fit to you", format: [] }],
    },
  },
  [ProductFitScreen_ViewVariant.success]: {
    activeColor: "Other/Success",
    bgImage: "https://storage.pora.ai/ac137667f507f5fc7d7c120355a1588c.webp",
    moreProductsTitle: "+18",
    bgColor: "#022003",
    prevTotalProductsCount: 63,
    totalProductsCount: 31,
    fitPercentage: 88,
    prevFitPercentage: 74,
    title1: { parts: [{ content: " products", format: [] }] },
    title2: {
      parts: [{ content: " fit to you", format: [] }],
    },
  },
  [ProductFitScreen_ViewVariant.top]: topScreen,
  [ProductFitScreen_ViewVariant.unknown]: topScreen,
  [ProductFitScreen_ViewVariant.UNRECOGNIZED]: topScreen,
}
